<template>
  <v-container class="p-4">
    <section class="d-flex flex-column flex-sm-row justify-content-between">
      <h2 class="ml-1 my-3 font-weight-bold">Aprobaciones Administrativas</h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </section>
    <v-data-table
      class="elevation-1 px-5 py-3 mt-1"
      :headers="tableHeaders"
      :items="wrappedEmployeesDataWithAmounts"
      :loading="loading"
      loading-text="Cargando aprobaciones"
      item-key="id"
      no-data-text="Sin aprobaciones"
    >
      <template v-slot:item.charge="{ item }">
        <span>
          {{ item.charge }}
        </span>
      </template>
      <template v-slot:item.email="{ item }">
        <span>
          {{ item.charge !== CHARGE_BUYER ? item.email : "CECO AB-CPRA" }}
        </span>
      </template>
      <template v-slot:item.max_amount="{ item }">
        <span>
          {{
            item.charge !== CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER &&
            item.amount
              ? `$ ${item.amount.toLocaleString("es-ES", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}`
              : "-"
          }}
        </span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openModalUpdateAdministrativeApproval(item)"
                icon
                color="warning"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modificar</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <update-administrative-approval
      :modalAction="dialogUpdateAdministrativeApproval"
      :closeModalUpdateAdministrativeApproval="
        closeModalUpdateAdministrativeApproval
      "
      :currentAdministrativeApproval="currentAdministrativeApproval"
      @administrativeApprovalUpdated="getAllData"
    ></update-administrative-approval>
  </v-container>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { mapActions, mapGetters } from "vuex";
import UpdateAdministrativeApproval from "./UpdateAdministrativeApproval.vue";
import config from "@/config";
import {
  CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER,
  CHARGE_BUYER,
} from "@/constants/maintainers";

export default {
  components: { UpdateAdministrativeApproval },
  mounted() {
    this.getAllData();
  },
  data() {
    return {
      CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER,
      CHARGE_BUYER,
      breadcrumb: [
        {
          text: "Proyectos",
          disabled: false,
          href: "/",
        },
        {
          text: "Aprobaciones Administrativas",
          disabled: true,
          href: "/mantenedores/aprobaciones/administrativas",
        },
      ],
      dialogUpdateAdministrativeApproval: false,
      currentAdministrativeApproval: null,
      loading: false,
      debounce: null,
      debounceTime: 500,
      pageCount: 0,
      tableHeaders: [
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: "Cargo",
          align: "center",
          sortable: true,
          value: "charge",
        },
        {
          text: "Empleado",
          align: "center",
          sortable: false,
          value: "email",
        },
        {
          text: "Monto Máximo",
          align: "center",
          sortable: true,
          value: "max_amount",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getBusinessUnits: "requestMaterial/getBusinessUnits",
      sendGetAdministrationApprovals: "maintainers/getAdministrativeApprovals",
      getEmployees: "maintainers/getEmployees",
    }),
    async getAllData() {
      await this.getAdministrativeApprovals();
      await this.getEmployeesData();
    },
    async getEmployeesData() {
      await this.getEmployees({
        password: config.password_manteiners,
        page: 0,
        sale_approvers: true,
      });
    },
    async getAdministrativeApprovals() {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = setTimeout(async function() {
        self.loading = true;
        await self.sendGetAdministrationApprovals();
        self.loading = false;
      }, self.debounceTime);
    },
    openModalUpdateAdministrativeApproval(administrativeApproval) {
      this.currentAdministrativeApproval = administrativeApproval;
      this.dialogUpdateAdministrativeApproval = true;
    },
    closeModalUpdateAdministrativeApproval() {
      this.currentAdministrativeApproval = null;
      this.dialogUpdateAdministrativeApproval = false;
    },
  },
  computed: {
    ...mapGetters({
      administrativeApprovals: "maintainers/administrativeApprovals",
      employeesData: "maintainers/employees",
    }),
    wrappedEmployeesDataWithAmounts() {
      let self = this;
      if (
        this.administrativeApprovals.length &&
        this.employeesData.employees.length
      ) {
        return this.employeesData.employees.map(function(item) {
          return {
            sale_order_index: item.sale_department_index,
            charge: item.sale_department_position,
            email: item.email,
            amount: self.administrativeApprovals.find(
              (approval) =>
                approval.sale_order_index === item.sale_department_index
            )?.amount,
          };
        });
      }
      return [];
    },
  },
};
</script>

<style></style>
